import { motion } from "framer-motion";
import styled, { css } from "styled-components";

export const levelColumnVariants = {
  hidden: {
    opacity: 0,
    x: 50,
    scale: 0.95
  },
  visible: {
    opacity: 1,
    x: 0,
    scale: 1,
    transition: {
      duration: 0.3,
      ease: "easeOut",
      staggerChildren: 0.1
    }
  },
  exit: {
    opacity: 0,
    x: -50,
    scale: 0.95,
    transition: {
      duration: 0.2,
      ease: "easeIn"
    }
  }
};

export const breadcrumbItemVariants = {
  hidden: {
    opacity: 0,
    scale: 0.9
  },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.25,
      ease: "easeOut"
    }
  },
  exit: {
    opacity: 0,
    scale: 0.9,
    transition: {
      duration: 0.2,
      ease: "easeIn"
    }
  }
};

export const Container = styled.div`
  border-radius: 4px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  border: 1px solid var(--primary-dark-200);
`;

export const customBtnStyles = css`
  height: 30px;
  font-size: var(--fs-sm);
  width: fit-content;
`;

export const Breadcrumb = styled.div`
  font-size: var(--fs-sm);
  color: var(--primary-dark);
  line-height: var(--lh-sm);
  font-family: Rubik;
`;

export const LevelsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 15px;
`;

export const LevelColumn = styled(motion.div)`
  min-width: 200px;
  max-width: 250px;
`;

export const LevelTitle = styled.h4`
  margin: 0 0 10px 0;
  font-size: var(--fs-sm);
  font-family: Rubik;
  font-weight: 500;
`;

export const CategoriesList = styled.div`
  max-height: 300px;
  border-radius: 4px;
  overflow-y: auto;
  border: 1px solid var(--primary-blue-400);
  background-color: var(--primary-white);
`;

export const CategoryItem = styled.div`
  padding: 8px 12px;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  gap: 4px;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--primary-blue-400);
  background-color: ${({ selected }) =>
    selected ? "var(--primary-dark-100)" : "var(--primary-white)"};

  &:hover {
    background-color: ${({ selected }) =>
      selected ? "var(--primary-dark-100)" : "var(--primary-dark-200)"};
  }

  svg[id="arrow-narrow-right"] {
    flex-shrink: 0;
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const CategoryName = styled.div`
  font-size: var(--fs-sm);
  font-family: Rubik;
  line-height: var(--lh-sm);
`;
